/**
 * FormProgress Component
 * 
 * Displays a visual progress bar showing form completion percentage
 */

import React from 'react';
import { ProgressBar } from 'react-bootstrap';

const FormProgress = ({ progress = 0 }) => {
  const getVariant = (progress) => {
    if (progress < 30) return 'danger';
    if (progress < 70) return 'warning';
    return 'success';
  };

  return (
    <div className="form-progress">
      <ProgressBar
        now={progress}
        variant={getVariant(progress)}
        style={{ height: '8px', minWidth: '100px' }}
        className="rounded-pill"
      />
    </div>
  );
};

export default FormProgress;